const $ = require('jquery');

module.exports = (app) => {
  app.channel.on('renderPros', async (prosObj) => {
    const prosPanelEl = $('#prosPanel');
    if (prosObj.productId) {
      prosPanelEl.data({
        productid: prosObj.productId,
      });
    }

    if (prosObj.context) {
      prosPanelEl.data({
        context: prosObj.context,
      });
    }

    await import('@feature/pros-factory');
    Object.assign(app.meta.properties, prosObj.killswitches);
    app.channel.trigger('pros-factory:initialize');
  });

  return app;
};
